import { z } from 'zod';
import { ProjectSettingsResponseSchema, ResolvedProjectContentSchema } from './Config.js';
export const PublishResponseSchema = z
    .object({
    publicId: z.string(),
    publishedAt: z.string().datetime(),
    version: z.number().multipleOf(1).nonnegative(),
})
    .strict();
export const PublishStatusResponseSchema = z
    .object({
    projectId: z.string(),
    publicId: z.string(),
    currentVersion: z.number().multipleOf(1).nonnegative(),
    vapiAssistantId: z.string().nullable(),
    publishedAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
})
    .strict();
export const PublishedProjectResponseSchema = z
    .object({
    projectId: z.string(),
    organizationId: z.string(),
    publicId: z.string(),
    configVersion: z.number().multipleOf(1).nonnegative(),
    content: ResolvedProjectContentSchema,
    settings: ProjectSettingsResponseSchema,
})
    .strict();
export const UpdateVapiAssistantRequestSchema = z
    .object({
    vapiAssistantId: z.string().nullable(),
    assistantVoiceProvider: z.enum(['vapi', 'elevenlabs']).nullable().optional(),
})
    .strict();
export const PublishedVoiceProviderResponseSchema = z
    .object({ voiceProvider: z.enum(['vapi', 'elevenlabs']) })
    .strict();
//# sourceMappingURL=Publish.js.map